import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Button,
    TextField,
    Typography,
    Snackbar,
    Alert,
    Backdrop,
    CircularProgress,
} from "@mui/material";

const Bullet = () => {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    const [bulletName, setBulletName] = useState("");
    const [bullets, setBullets] = useState([
        { id: 1, name: "Sample Bullet 1" },
        { id: 2, name: "Sample Bullet 2" },
    ]);

    const handleAddBullet = () => {
        if (bulletName.trim() === "") {
            setError("Bullet name cannot be empty!");
            return;
        }
        const newBullet = { id: Date.now(), name: bulletName };
        setBullets([...bullets, newBullet]);
        setBulletName("");
        setSuccess("Bullet added successfully!");
    };

    const handleDeleteBullet = (id) => {
        setBullets(bullets.filter((b) => b.id !== id));
        setSuccess("Bullet deleted successfully!");
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <Box sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Bullet Panel
                </Typography>

                {/* Input and Add Button */}
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        mb: 2,
                        alignItems: "center",
                        width: "100%",
                        maxWidth: 400,
                    }}
                >
                    <TextField
                        label="Enter Bullet Name"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={bulletName}
                        onChange={(e) => setBulletName(e.target.value)}
                    />
                    <Button variant="contained" color="primary" onClick={handleAddBullet} sx={{
                                                color: "White",                // 🔴 red text
                                                fontWeight: "bold",          // optional: bold like your screenshot
                                                "&:hover": {
                                                    backgroundColor: "transparent", // no background on hover
                                                    textDecoration: "underline",    // optional underline on hover
                                                },
                                            }}>
                        Add
                    </Button>
                </Box>

                {/* Bullets Table */}
                <TableContainer component={Paper} >
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Bullet Name</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                            </TableRow>

                            {bullets.map((bullet) => (
                                <TableRow key={bullet.id}>
                                    <TableCell>{bullet.name}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="text"
                                            size="small"
                                            onClick={() => handleDeleteBullet(bullet.id)}
                                            sx={{
                                                color: "red",                // 🔴 red text
                                                fontWeight: "bold",          // optional: bold like your screenshot
                                                "&:hover": {
                                                    backgroundColor: "transparent", // no background on hover
                                                    textDecoration: "underline",    // optional underline on hover
                                                },
                                            }}
                                        >
                                            Delete
                                        </Button>

                                    </TableCell>
                                </TableRow>
                            ))}

                            {bullets.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={2} align="center">
                                        No bullets added yet.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            <Footer />

            {/* Snackbar Notifications */}
            <Snackbar
                open={!!error || !!success}
                autoHideDuration={3000}
                onClose={() => {
                    setError(null);
                    setSuccess(null);
                }}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={() => {
                        setError(null);
                        setSuccess(null);
                    }}
                    severity={error ? "error" : "success"}
                    sx={{ width: "100%" }}
                >
                    {error || success}
                </Alert>
            </Snackbar>

            {/* Loading Backdrop */}
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </DashboardLayout>
    );
};

export default Bullet;
